import React, { useEffect, useState } from 'react';
import './ManageStallUsers.scss';
import { http, FxInput, AlertService, formValidator } from '../../fx-core';
import { Button, Dialog, Menu, MenuItem } from '@material-ui/core';
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';


const ManageStallUsers = (props) => {
  console.log("ManageStallUsers props:", props);
  
  let defaultItem = {
    id: 0,
    userId: 0,
    stallId: props.stallId,
    email: "",
    role: "Member"
  };
  
  const [item, setItem] = useState(defaultItem);
  const [errors, setErrors] = useState({});
  const [stallUsers, setStallUsers] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [message, setMessage] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [actionType, setActionType] = useState("");
  const [roleMenuAnchor, setRoleMenuAnchor] = useState(null);

  // Get current authenticated user ID from localStorage
  const getCurrentUserId = () => {
    return localStorage.getItem("userId");
  };

  const handleInputChange = (item) => {
    handleItemChange({ [item.name]: item.value });
  };

  const handleItemChange = (data) => {
    setItem(prevState => {
      return { ...prevState, ...data }
    });
  };

  const getStallUsers = () => {
    let apiOptions = {
      url: `stall/${props.stallId}/access/list`
    };
    http.get(apiOptions).then(res => {
      getStallUsersCallBack(res);
    }).catch(error => {
      console.error("Error fetching stall users:", error);
    });
  };

  const getStallUsersCallBack = (res) => {
    const result = res.data;
    console.log("Stall users data:", result);
    setStallUsers(result);
  };

  // Check if current logged-in user is the stall owner
  const isOwner = stallUsers.some(user => 
    user.role === "Owner" && 
    user.userId.toString() === getCurrentUserId()
  );

  console.log("Is current user owner?", isOwner, "Current User ID:", getCurrentUserId());

  // Get current user's email for display
  const getCurrentUserEmail = () => {
    const currentUserId = getCurrentUserId();
    const currentUser = stallUsers.find(user => user.userId.toString() === currentUserId);
    return currentUser ? currentUser.email : "";
  };

  const handleClose = () => {
    props.handleManageUsersClose();
  };

  // Role menu functions
  const openRoleMenu = (event) => {
    setRoleMenuAnchor(event.currentTarget);
  };

  const closeRoleMenu = () => {
    setRoleMenuAnchor(null);
  };

  const handleRoleChange = (role) => {
    handleItemChange({ role });
    setRoleMenuAnchor(null);
  };

  const validationMap = {
    email: ["required", "email"]
  };

  const bulkValidate = () => {
    let items = [];
    for (var key in validationMap) {
      let itemVal = { name: key, value: item[key], validations: validationMap[key] }
      items.push(itemVal);
    }
    let validationResult = formValidator.bulkValidate(items);
    updateErrors(validationResult.errors);
    return validationResult.isValid;
  }

  const updateErrors = (validationData) => {
    setErrors(prevState => {
      return { ...prevState, ...validationData }
    });
  }

  const hasError = (field, validationMethod) => {
    return (
      errors &&
      errors[field] &&
      errors[field][validationMethod]
    );
  };

  const sendInviteLink = () => {
    const isValid = bulkValidate();
    if (isValid) {
      let inputData = {
        email: item.email,
        stallId: item.stallId,
        role: item.role
      };
      
      console.log("Sending invite with data:", inputData);
      
      let apiOptions = {
        url: `stall/transfer/mailinvitelink`,
        data: inputData
      };
      
      http.post(apiOptions).then(res => {
        sendInviteLinkCallBack(res);
      }).catch(error => {
        console.error("Error sending invite:", error);
        AlertService.showMsg({ 
          message: error.response?.data?.message || "Error sending invite", 
          type: 'error' 
        });
      });
    }
  };

  const sendInviteLinkCallBack = (res) => {
    AlertService.showMsg({ message: "Invite processed successfully" });
    setItem(defaultItem);
    getStallUsers();
  };

  // MISSING ACTION FUNCTIONS - ADD THESE:

  const confirmAction = (user, action) => {
    setSelectedItem(user);
    setActionType(action);
    
    switch(action) {
      case 'remove':
        setMessage(`Do you want to remove access for ${user.userName || user.email}?`);
        break;
      case 'transfer':
        setMessage(`Do you want to transfer ownership to ${user.userName || user.email}? You will become an Access member.`);
        break;
      default:
        setMessage("Are you sure?");
    }
    
    setConfirmOpen(true);
  }

  const handleDialogClose = () => {
    setConfirmOpen(false);
    setSelectedItem({});
    setActionType("");
  };

  const onConfirmCallback = () => {
    switch(actionType) {
      case 'remove':
        removeStallAccess(selectedItem);
        break;
      case 'transfer':
        transferOwnership(selectedItem);
        break;
      default:
        console.log('Unknown action');
    }
    handleDialogClose();
  }

  const removeStallAccess = (user) => {
    let apiOptions = {
      url: `stall/access/remove`,
      data: {
        stallId: user.stallId,
        email: user.email
      }
    };
    
    console.log("Removing stall access:", apiOptions.data);
    
    http.post(apiOptions).then(res => {
      removeStallAccessCallBack(res);
    }).catch(error => {
      AlertService.showMsg({ 
        message: error.response?.data?.message || "Error removing access", 
        type: 'error' 
      });
    });
  };

  const removeStallAccessCallBack = (res) => {
    AlertService.showMsg({ message: "Access removed successfully" });
    getStallUsers(); // Refresh the list
  };

  const transferOwnership = (user) => {
    let apiOptions = {
      url: `stall/transfer/mailinvitelink`,
      data: {
        stallId: user.stallId,
        email: user.email,
        role: "Owner"
      }
    };
    
    console.log("Transferring ownership:", apiOptions.data);
    
    http.post(apiOptions).then(res => {
      transferOwnershipCallBack(res);
    }).catch(error => {
      AlertService.showMsg({ 
        message: error.response?.data?.message || "Error transferring ownership", 
        type: 'error' 
      });
    });
  };

  const transferOwnershipCallBack = (res) => {
    AlertService.showMsg({ message: "Ownership transferred successfully" });
    getStallUsers(); // Refresh the list
  };

  // Check if user can be removed (not owner and current user is owner)
  const canRemoveUser = (user) => {
    return isOwner && user.role !== "Owner";
  };

  // Check if ownership can be transferred (current user is owner and target user is not owner)
  const canTransferOwnership = (user) => {
    return isOwner && user.role !== "Owner" && user.userId.toString() !== getCurrentUserId();
  };

  useEffect(() => {
    getStallUsers();
  }, [props.stallId]);

  return (
    <div className='managestallusers-ui confirmContainer'>
      <div className="row justify-content-between title-font px-3">
        <div className="py-1 pl-3">
          <span>Manage Stall Users</span>
        </div>
        <div className="text-right pointer my-auto">
          <i className="fas fa-times-circle font-16 pr-3" onClick={handleClose}></i>
        </div>
      </div>

      {/* Only show invite section if current user is owner */}
    
        <div className="row my-2 p-3 justify-content-between">
          <div className="col-12 row">
            <div className="col-5 py-3">
              <FxInput 
                name="email" 
                variant="outlined" 
                label="Email"
                value={item.email}
                fullWidth
                size="small"
                onValueChange={handleInputChange} 
              />
              {hasError("email", "required") && (
                <div className="validation-msg">Email is required</div>
              )}
              {hasError("email", "email") && (
                <div className="validation-msg">Please enter valid Email</div>
              )}
            </div>
            <div className="col-4 py-3">
              <Button 
                variant="outlined" 
                size="small" 
                onClick={openRoleMenu}
                fullWidth
                style={{ justifyContent: 'space-between' }}
              >
                {item.role || "Select Role"}
                <i className="fas fa-chevron-down ml-2"></i>
              </Button>
              <Menu
                anchorEl={roleMenuAnchor}
                keepMounted
                open={Boolean(roleMenuAnchor)}
                onClose={closeRoleMenu}
              >
                <MenuItem onClick={() => handleRoleChange("Access")}>Member</MenuItem>
                {
                  isOwner && (
                <MenuItem onClick={() => handleRoleChange("Owner")}>Owner</MenuItem>

                  )
                }
              </Menu>
            </div>
            <div className="col-3 py-3">
              <Button 
                variant="contained" 
                size="small" 
                color="primary" 
                onClick={sendInviteLink}
                fullWidth
              >
                {item.role === "Owner" ? "Transfer" : "Invite"}
              </Button>
            </div>
          </div>
          {item.role === "Owner" && (
            <div className="col-12">
              <div className="alert alert-warning mt-2 py-2">
                <small>
                  <i className="fas fa-exclamation-triangle mr-2"></i>
                  <strong>Owner Transfer:</strong> This will immediately transfer ownership to the specified user. You will become an Access member.
                </small>
              </div>
            </div>
          )}
        </div>
      
      {/* Show message if not owner */}
      {/* {!isOwner && (
        <div className="row p-3">
          <div className="col-12">
            <div className="alert alert-info">
              <small>
                <strong>Access Limited:</strong> Only stall owners can manage transfer ownership.
              </small>
            </div>
          </div>
        </div>
      )} */}

      {/* Users List */}
      <div className="row p-3">
        <div className="col-12">
          <div className="user-list-header row py-2 border-bottom">
            <div className="col-4"><strong>User Name</strong></div>
            <div className="col-4"><strong>Email</strong></div>
            <div className="col-2"><strong>Role</strong></div>
            {
              isOwner && (
            <div className="col-2"><strong>Actions</strong></div>

              )
            }
          </div>
          
          {stallUsers.map((user, index) => (
            <div key={user.id || index} className="row py-2 border-bottom align-items-center">
              <div className="col-4">
                {user.userName || "No Name"}
                {user.userId.toString() === getCurrentUserId() && (
                  <span className="badge badge-primary ml-2">You</span>
                )}
              </div>
              <div className="col-4">{user.email}</div>
              <div className="col-2">
                <span className={`badge ${
                  user.role === "Owner" ? "badge-warning" : "badge-info"
                }`}>
                  {user.role === "Owner" ? "Owner" : "Member"}
                </span>
              </div>
              <div className="col-2 text-right">
                {/* Action buttons - only show if current user is owner */}
                {isOwner && (
                  <div className="action-buttons">
                    {/* Show transfer button for non-owner users */}
                    {canTransferOwnership(user) && (
                      <i 
                        className="fas  font-13 text-warning mr-2 pointer" 
                        onClick={() => confirmAction(user, 'transfer')}
                        title="Transfer Ownership"
                      ></i>
                    )}
                    
                    {/* Show remove button for non-owner users */}
                    {canRemoveUser(user) && (
                      <i 
                        className="fas fa-trash-alt font-13 pointer" 
                        onClick={() => confirmAction(user, 'remove')}
                        title="Remove Access"
                      ></i>
                    )}
                    
                    {/* Show crown icon for owner */}
                    {/* {user.role === "Owner" && (
                      <i className="fas fa-crown font-13 text-warning mr-2" title="Owner"></i>
                    )} */}
                  </div>
                )}
                
                {/* Show if no actions available and user is not owner */}
                {!isOwner && user.role !== "Owner" && (
                  <span className="text-muted"></span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Confirmation Dialog */}
      <Dialog
        open={confirmOpen}
        maxWidth="sm"
        fullWidth
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <ConfirmDialog 
          message={message} 
          handleDialogClose={handleDialogClose} 
          onConfirmCallback={onConfirmCallback} 
        />
      </Dialog>
    </div>
  );
};

export default ManageStallUsers;